import React from "react";

function Yes() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 60 60"
    >
      <circle
        cx="30"
        cy="30"
        r="29"
        fill="#5edd60"
        data-original="#5edd60"
      ></circle>
      <path
        fill="#fff"
        d="M24.262 42.07l-6.8-6.642a1.534 1.534 0 010-2.2l2.255-2.2a1.621 1.621 0 012.256 0l4.048 3.957 11.353-17.26a1.617 1.617 0 012.2-.468l2.684 1.686a1.537 1.537 0 01.479 2.154L29.294 41.541a3.3 3.3 0 01-5.032.529z"
        data-original="#ffffff"
      ></path>
    </svg>
  );
}

export default Yes;
